package org.multipaz.utopia.generated

/**
 * Generated strings for language: ko
 * DO NOT EDIT - This file is auto-generated by the generateMultipazStrings task
 */
internal val strings_ko = mapOf(
    "boarding_pass_attribute_departure_time" to "출발 시간",
    "boarding_pass_attribute_flight_number" to "항공편 번호",
    "boarding_pass_attribute_passenger_name" to "승객 이름",
    "boarding_pass_attribute_seat_number" to "좌석 번호",
    "boarding_pass_description_departure_time" to "출발 일시입니다.",
    "boarding_pass_description_flight_number" to "항공편 번호입니다.",
    "boarding_pass_description_passenger_name" to "mDL 소지자의 성, 이름 또는 기본 식별자입니다.",
    "boarding_pass_description_seat_number" to "좌석 번호입니다.",
    "cor_attribute_administrative_number" to "관리 번호",
    "cor_attribute_date_of_arrival" to "도착일",
    "cor_attribute_date_of_birth" to "생년월일",
    "cor_attribute_date_of_expiry" to "만료일",
    "cor_attribute_date_of_issue" to "발급일",
    "cor_attribute_document_number" to "문서 번호",
    "cor_attribute_family_name" to "성",
    "cor_attribute_gender" to "성별",
    "cor_attribute_given_names" to "이름",
    "cor_attribute_issuing_authority" to "발급 기관",
    "cor_attribute_issuing_country" to "발급 국가",
    "cor_attribute_issuing_jurisdiction" to "발급 관할",
    "cor_attribute_nationality" to "국적",
    "cor_attribute_older_than_18" to "18세 이상",
    "cor_attribute_older_than_21" to "21세 이상",
    "cor_attribute_place_of_birth" to "출생지",
    "cor_attribute_resident_address" to "거주지 주소",
    "cor_attribute_resident_city" to "거주 도시",
    "cor_attribute_resident_country" to "거주 국가",
    "cor_attribute_resident_house_number" to "거주 건물 번호",
    "cor_attribute_resident_postal_code" to "거주 우편번호",
    "cor_attribute_resident_state" to "거주 주/도",
    "cor_attribute_resident_street" to "거주 도로명",
    "cor_description_administrative_number" to "감사 관리 또는 기타 목적으로 COR 제공자가 할당한 번호.",
    "cor_description_date_of_arrival" to "COR 소지자가 EU에 도착한 일, 월, 연도",
    "cor_description_date_of_birth" to "COR 소지자가 태어난 일, 월, 연도. 알 수 없는 경우, 대략적인 생년월일.",
    "cor_description_date_of_expiry" to "COR 만료 날짜(및 시각)",
    "cor_description_date_of_issue" to "COR 발급 날짜(및 시각)",
    "cor_description_document_number" to "COR 제공자가 할당한 COR 번호.",
    "cor_description_family_name" to "COR 소지자의 현재 성 또는 주요 식별자",
    "cor_description_gender" to "COR 소지자의 성별",
    "cor_description_given_names" to "COR 소지자의 현재 이름 또는 보조 식별자",
    "cor_description_issuing_authority" to "이 COR 인스턴스를 발급한 행정 당국의 이름 또는 COR 발급 권한이 있는 별도의 당국이 없는 경우 해당 회원국의 ISO 3166 알파-2 국가 코드.",
    "cor_description_issuing_country" to "발급 당국의 국가 또는 영토의 알파-2 국가 코드(ISO 3166-1에 정의됨)",
    "cor_description_issuing_jurisdiction" to "COR을 발급한 관할 구역의 국가 세분 코드(ISO 3166-2:2020, 8절에 정의됨). 코드의 첫 부분은 issuing_country 값과 동일해야 합니다.",
    "cor_description_nationality" to "사용자의 국적(ISO 3166-1에 명시된 알파-2 국가 코드)",
    "cor_description_older_than_18" to "18세 이상입니까?",
    "cor_description_older_than_21" to "21세 이상입니까?",
    "cor_description_place_of_birth" to "COR 소지자의 출생지",
    "cor_description_resident_address" to "COR 소지자가 현재 거주하거나 연락 가능한 장소의 전체 주소 (도로명/번지, 시/군/구 등)",
    "cor_description_resident_city" to "COR 소지자의 현재 거주 도시",
    "cor_description_resident_country" to "사용자가 현재 거주하는 국가 (ISO 3166-1에 명시된 Alpha-2 국가 코드 형식)",
    "cor_description_resident_house_number" to "사용자의 현재 거주지 건물 번호(접두사 또는 접미사 포함)",
    "cor_description_resident_postal_code" to "COR 소지자의 현재 거주지 우편번호",
    "cor_description_resident_state" to "거주 중인 주/도, 구역 또는 지역.",
    "cor_description_resident_street" to "사용자의 현재 거주지 도로명",
    "cor_request_age_over_18" to "만 18세 이상",
    "cor_request_all_data_elements" to "모든 데이터 요소",
    "cor_request_mandatory_data_elements" to "필수 데이터 요소",
    "document_display_name_boarding_pass" to "탑승권",
    "document_display_name_certificate_of_residency" to "거주 증명서",
    "document_display_name_german_personal_id" to "독일 신분증",
    "document_display_name_loyalty_card" to "로열티 카드",
    "document_display_name_movie_ticket" to "영화표",
    "document_display_name_naturalization_certificate" to "귀화 증명서",
    "document_display_name_payment_card" to "결제 카드",
    "german_id_attribute_administrative_number" to "행정 번호",
    "german_id_attribute_age_in_years" to "나이",
    "german_id_attribute_city_of_birth" to "출생 도시",
    "german_id_attribute_country_of_birth" to "출생 국가",
    "german_id_attribute_date_of_birth" to "생년월일",
    "german_id_attribute_date_of_expiry" to "만료일",
    "german_id_attribute_date_of_issue" to "발급일",
    "german_id_attribute_document_number" to "문서 번호",
    "german_id_attribute_family_name" to "성",
    "german_id_attribute_family_name_at_birth" to "출생 시 성",
    "german_id_attribute_gender" to "성별",
    "german_id_attribute_given_names" to "이름",
    "german_id_attribute_issuing_authority" to "발급 기관",
    "german_id_attribute_issuing_country" to "발행 국가",
    "german_id_attribute_issuing_jurisdiction" to "발행 관할권",
    "german_id_attribute_nationality" to "국적",
    "german_id_attribute_older_than_12" to "12세 초과",
    "german_id_attribute_older_than_14" to "14세 초과",
    "german_id_attribute_older_than_16" to "16세 이상",
    "german_id_attribute_older_than_18" to "18세 이상",
    "german_id_attribute_older_than_21" to "21세 이상",
    "german_id_attribute_older_than_65" to "65세 이상",
    "german_id_attribute_place_of_birth" to "출생지",
    "german_id_attribute_resident_address" to "거주지 주소",
    "german_id_attribute_resident_city" to "거주 도시",
    "german_id_attribute_resident_country" to "거주 국가",
    "german_id_attribute_resident_postal_code" to "거주 우편번호",
    "german_id_attribute_state_of_birth" to "출생 주",
    "german_id_attribute_year_of_birth" to "출생 연도",
    "german_id_description_administrative_number" to "감사 관리 또는 기타 목적으로 PID 제공업체가 할당하는 번호입니다.",
    "german_id_description_age_in_years" to "PID 소지자의 만 나이",
    "german_id_description_city_of_birth" to "PID 사용자가 태어난 자치구, 도시, 읍 또는 마을",
    "german_id_description_country_of_birth" to "PID 사용자가 태어난 국가 (ISO 3166-1에 명시된 Alpha-2 국가 코드 형식)",
    "german_id_description_date_of_birth" to "PID 소지자의 출생일. 알 수 없는 경우, 대략적인 생년월일.",
    "german_id_description_date_of_expiry" to "PID가 만료되는 일자 (및 가능하면 시간)",
    "german_id_description_date_of_issue" to "PID가 발행된 일자 (및 가능하면 시간)",
    "german_id_description_document_number" to "PID 제공업체가 PID에 할당하는 번호입니다.",
    "german_id_description_family_name" to "현재 성(姓) 또는 PID 소지자의 주 식별자",
    "german_id_description_family_name_at_birth" to "출생 시 PID 소지자의 성(姓), 본명 또는 주요 식별자",
    "german_id_description_gender" to "PID 소지자의 성별",
    "german_id_description_given_names" to "현재 이름 또는 PID 소지자의 보조 식별자",
    "german_id_description_issuing_authority" to "이 PID 인스턴스를 발행한 행정 기관의 이름 또는, PID 발행 권한을 가진 별도 기관이 없는 경우 해당 회원국의 ISO 3166 알파-2 국가 코드",
    "german_id_description_issuing_country" to "ISO 3166-1에 정의된, 발행 기관의 국가 또는 지역의 알파-2 국가 코드입니다.",
    "german_id_description_issuing_jurisdiction" to "ISO 3166-2:2020, 8조에 정의된, PID를 발급한 관할 구역의 국가 세분화 코드입니다. 코드의 첫 부분은 발행 국가 값과 동일해야 합니다.",
    "german_id_description_nationality" to "ISO 3166-1에 명시된 PID 사용자의 국적을 나타내는 알파-2 국가 코드 목록",
    "german_id_description_older_than_12" to "만 12세 이상인가요?",
    "german_id_description_older_than_14" to "만 14세 이상인가요?",
    "german_id_description_older_than_16" to "만 16세 이상인가요?",
    "german_id_description_older_than_18" to "만 18세 이상인가요?",
    "german_id_description_older_than_21" to "만 21세 이상인가요?",
    "german_id_description_older_than_65" to "만 65세 이상인가요?",
    "german_id_description_place_of_birth" to "PID 소지자가 태어난 국가 및 시/군 또는 주/도",
    "german_id_description_resident_address" to "PID 소지자가 현재 거주하거나 연락 가능한 장소의 전체 주소 (거리/번지, 자치구 등)",
    "german_id_description_resident_city" to "PID 소지자가 현재 거주하는 도시",
    "german_id_description_resident_country" to "PID 사용자가 현재 거주하는 국가를 ISO 3166-1에 명시된 알파-2 국가 코드로 표시",
    "german_id_description_resident_postal_code" to "PID 소지자가 현재 거주하는 곳의 우편번호",
    "german_id_description_state_of_birth" to "PID 사용자가 태어난 주, 도, 구 또는 지역",
    "german_id_description_year_of_birth" to "PID 소지자의 출생 연도",
    "german_id_request_age_over_18" to "만 18세 이상",
    "german_id_request_all_data_elements" to "모든 정보 항목",
    "german_id_request_mandatory_data_elements" to "필수 정보 항목",
    "loyalty_attribute_date_of_expiry" to "만료일",
    "loyalty_attribute_date_of_issue" to "발급일",
    "loyalty_attribute_family_name" to "성",
    "loyalty_attribute_given_names" to "이름",
    "loyalty_attribute_membership_id" to "회원 ID",
    "loyalty_attribute_photo_of_holder" to "소지자 사진",
    "loyalty_attribute_tier" to "등급",
    "loyalty_description_date_of_expiry" to "문서 만료일",
    "loyalty_description_date_of_issue" to "문서 발급일",
    "loyalty_description_family_name" to "문서 소지자의 성 또는 기본 식별자",
    "loyalty_description_given_names" to "문서 소지자의 이름 또는 보조 식별자",
    "loyalty_description_membership_id" to "로열티 ID 소지자의 개인 식별자",
    "loyalty_description_photo_of_holder" to "문서 소지자의 초상 사진",
    "loyalty_description_tier" to "회원 등급 (일반, 실버, 골드, 플래티넘, 엘리트)",
    "loyalty_request_all_data_elements" to "모든 데이터 요소",
    "loyalty_request_mandatory_data_elements" to "필수 데이터 요소",
    "movie_ticket_attribute_age_rating_code" to "관람 등급 코드",
    "movie_ticket_attribute_cinema_theater" to "영화관",
    "movie_ticket_attribute_date_and_time_of_show" to "상영 일시",
    "movie_ticket_attribute_movie_poster" to "영화 포스터",
    "movie_ticket_attribute_movie_title" to "영화 제목",
    "movie_ticket_attribute_parking" to "주차",
    "movie_ticket_attribute_seat" to "좌석",
    "movie_ticket_attribute_theater" to "극장",
    "movie_ticket_attribute_ticket_number" to "티켓 번호",
    "movie_ticket_description_age_rating_code" to "영화 연령 제한 등급",
    "movie_ticket_description_cinema_theater" to "입장 극장의 이름 및/또는 주소/위치",
    "movie_ticket_description_date_and_time_of_show" to "영화 시작 날짜 및 시간",
    "movie_ticket_description_movie_poster" to "영화 포스터",
    "movie_ticket_description_movie_title" to "영화 이름, 제목 및 기타 상영 식별 정보",
    "movie_ticket_description_parking" to "티켓 구매 시 주차 요금 선결제 여부",
    "movie_ticket_description_seat" to "좌석 번호 또는 코드",
    "movie_ticket_description_theater" to "상영관 이름 또는 번호",
    "movie_ticket_description_ticket_number" to "구매 시 발행된 티켓 식별/참조 번호",
    "movie_ticket_request_all_data_elements" to "모든 데이터 요소",
    "movie_ticket_request_prepaid_parking" to "선불 주차",
    "movie_ticket_request_ticket_number" to "티켓 번호",
    "naturalization_attribute_date_of_birth" to "생년월일",
    "naturalization_attribute_date_of_naturalization" to "귀화일",
    "naturalization_attribute_family_name" to "성",
    "naturalization_attribute_given_names" to "이름",
    "naturalization_description_date_of_birth" to "귀화자의 출생일. 알 수 없는 경우 추정 출생일.",
    "naturalization_description_date_of_naturalization" to "귀화한 날짜 (시간 포함)",
    "naturalization_description_family_name" to "귀화자의 현재 성(姓) 또는 주요 식별자",
    "naturalization_description_given_names" to "귀화자의 현재 이름 또는 보조 식별자",
    "naturalization_request_all_data_elements" to "모든 데이터 요소",
    "payment_attribute_expiry_date" to "만료일",
    "payment_attribute_holder_name" to "명의자 이름",
    "payment_attribute_issue_date" to "발급일",
    "payment_attribute_issuer_name" to "발급 기관명",
    "payment_attribute_masked_account_reference" to "마스킹된 계정 참조",
    "payment_attribute_payment_instrument_id" to "결제 수단 ID",
    "payment_description_expiry_date" to "이 자격 증명이 만료되는 날짜입니다.",
    "payment_description_holder_name" to "결제 계정 소유자 이름입니다.",
    "payment_description_issue_date" to "이 자격 증명이 발급된 날짜입니다.",
    "payment_description_issuer_name" to "발급기관의 읽기 쉬운 이름입니다.",
    "payment_description_masked_account_reference" to "마스킹된 계정 참조 (예: PAN 마지막 4자리).",
    "payment_description_payment_instrument_id" to "토큰화된 결제 수단 식별자입니다.",
    "payment_request_payment_sca_all" to "결제 SCA (모든 데이터 요소)",
    "payment_request_payment_sca_minimal" to "결제 SCA (최소)",
    "payment_request_payment_sca_transaction" to "결제 거래 연동 SCA"
)
